import { Dashboard } from '@/features/dashboard';

export const SchoolAdminDashboard = Dashboard;


export * from './ListDepartments';
export * from './CreateDepartment';
export * from './ListEmployees';
export * from './AddEmployee';
export * from './ListParents';
export * from './AddParent';
export * from './ListSubDepartments';
export * from './AddSubDepartment';
export * from './ListDepartmentLevels';
export * from './AddDepartmentLevel';
export * from './AssignEmployeeToLevel';
export * from './Tags';
export * from './Workflows';
export * from './CreateWorkflow';
export * from './WorkflowVisualizer';
export * from './SchoolSettings';
export * from './EmailSettings';
export * from './ListStudents';
export * from './Classes';


